import {Dispatch} from 'react';

export type ChangeAction<TFilter> = (filter: TFilter) => any;

export const withValueChanged = <TFilter, TFilterKey extends keyof TFilter>(
  existingFilter: TFilter,
  dispatchChangeAction: ChangeAction<TFilter>
) => (propertyName: TFilterKey) => (value: TFilter[TFilterKey]) => {
  dispatchChangeAction({
    ...existingFilter,
    [propertyName]: value,
  });
};

export const withValueChangedHook = <TFilter, TFilterKey extends keyof TFilter>(
  existingFilter: TFilter,
  changeAction: ChangeAction<TFilter>,
  dispatch: Dispatch<any>
) => (propertyName: TFilterKey) => (value: TFilter[TFilterKey]) => {
  dispatch(
    changeAction({
      ...existingFilter,
      [propertyName]: value,
    })
  );
};
